import { Image, Text } from '@ui/atoms';
import React from 'react';
import texts from '../en.json';
import Button from '@ui/atoms/design-system/Button';
import { buttonSizes, buttonTypes } from '@ui/atoms/utils/enums';
import { useRouter } from 'next/router';
import { mediaCoverages } from '@helpers/homepageData';
import MediaCard from '../MediaCoverage/MediaCard';
import VisibilitySensor from 'react-visibility-sensor';

const MediaCoverage = () => {
    const router = useRouter();

    return (
        <VisibilitySensor partialVisibility>
            {({ isVisible }) => (
                <div className="flex flex-col gap-10 py-10 md:pt-[56px] md:pb-18 px-4 lg:px-16 max-width-wrapper items-center">
                    <div className="gap-3 md:gap-4 flex flex-col w-full ">
                        <div className="flex justify-between">
                            <Text
                                className="h4-semibold md:h2-semibold text-primary-500"
                                content={texts.JiraafInTheNews}
                            />
                            <Button
                                buttonSize={buttonSizes.REGULAR}
                                buttonType={buttonTypes.TEXT_UNDERLINE}
                                buttonText={'See more'}
                                suffixComponent={
                                    <Image
                                        src="/images/arrow-right-2.svg"
                                        alt="arrow"
                                        className="w-4 h-4 mb-1"
                                    />
                                }
                                onClick={() => window.open('/media')}
                                className="!items-end hidden md:inline-flex"
                            />
                            <Button
                                buttonSize={buttonSizes.EXTRA_SMALL}
                                buttonType={buttonTypes.TEXT_UNDERLINE}
                                buttonText={'See more'}
                                suffixComponent={
                                    <Image
                                        src="/images/arrow-right-2.svg"
                                        alt="arrow"
                                        className="w-4 h-4 mt-[2px]"
                                    />
                                }
                                onClick={() => router.push('/media')}
                                className="!items-end md:hidden self-center mt-1"
                            />
                        </div>
                        <hr className="border-t border-dashed border-gray-400 w-full" />
                    </div>
                    <div className="w-full flex flex-wrap justify-center lg:justify-between gap-y-6 gap-x-2">
                        {mediaCoverages.slice(0, 5).map((data, index) => (
                            <div key={index}>
                                <MediaCard
                                    data={data}
                                    index={index}
                                    shouldLinkWork
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </VisibilitySensor>
    );
};

export default MediaCoverage;
